require("expose-loader?exposes=$,jQuery!jquery")
require("expose-loader?exposes=Cookies!js-cookie")
require("../modernizer/modernizr")
require("slick-carousel")
require("../modules/jquery.cookie-1.4.1.min.js")
require("bootstrap")
require("jquery-mask-plugin")
